import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-3" }
const _hoisted_3 = { style: {"margin":"-11px 0"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "mb-1 d-block" }, "Tickets In Progress", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "mb-0 fs-20" }, "1.35k", -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "area",
              height: "130",
              options: _ctx.ticketsInProgress,
              series: _ctx.progress
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
        _createElementVNode("span", { class: "fs-12" }, "This Month"),
        _createElementVNode("i", { class: "material-symbols-outlined text-danger" }, "trending_down")
      ], -1))
    ])
  ]))
}